// extracted by mini-css-extract-plugin
export var addToCartStyle = "product-page-module--addToCartStyle--zK1gU";
export var breadcrumb = "product-page-module--breadcrumb--CT850";
export var container = "product-page-module--container--L6uwe";
export var cutomimgWidth = "product-page-module--cutomimgWidth--9sgVJ";
export var fontSm = "product-page-module--fontSm--Wz1Iv";
export var header = "product-page-module--header--A-ai8";
export var horizontalBorder = "product-page-module--horizontalBorder--f8apT";
export var iconposition = "product-page-module--iconposition--Gkoo+";
export var labelFont = "product-page-module--labelFont--38-RU";
export var metaSection = "product-page-module--metaSection--f06g+";
export var noImagePreview = "product-page-module--noImagePreview--2zkMJ";
export var optionsWrapper = "product-page-module--optionsWrapper--HoAcB";
export var priceValue = "product-page-module--priceValue--z6d6A";
export var productBox = "product-page-module--productBox--aFVTx";
export var productDescription = "product-page-module--productDescription--kGKL-";
export var productImageList = "product-page-module--productImageList--v3DbR";
export var productImageWrapper = "product-page-module--productImageWrapper--THmXX";
export var radioStyle = "product-page-module--radioStyle--W2p-D";
export var radioStyles = "product-page-module--radioStyles--28xp5";
export var salelock = "product-page-module--salelock--otN6p";
export var scrollForMore = "product-page-module--scrollForMore--5LYBj";
export var selectedmenu = "product-page-module--selectedmenu--JLcjz";
export var tagList = "product-page-module--tagList--qVxz0";
export var visuallyHidden = "product-page-module--visuallyHidden--GwM5Y";